export default[
    {
        path: 'trail',
        name: 'trail',
        component: () => import(/* webpackChunkName: "trailManage" */ '@/views/company/trailManage/index.vue'),
    },
];
